module.exports = __webpack_public_path__ + "img/9788954635653.19125a06.jpg";